<template>
    <div v-if="typeId" class="r-column-title pb20 ofhidden">
        <div class="crumb pt10 pb10 pl20">
            <template v-if="isBack">
                <span  @click="goBack()" class="iconfont icon-fanhui1 fs22 cpointer mr20" title="返回上一页"></span>
            </template>
            <span v-else class="iconfont icon-wxbdingwei fs20 mr5 prelative"></span>
            <a :href="$params.baseDir">首页&nbsp;&gt;&nbsp;</a>
            <router-link 
                v-for="item in $params.newsType[typeId]['parents']" 
                :to="$params.newsType[item]['to']" 
                :key="item">{{$params.newsType[item]['stitle']}}&nbsp;&gt;&nbsp;
            </router-link>
            <span>{{$params.newsType[typeId]['stitle']}}</span>
        </div>
        <div v-if="showTitle" class="fs22 stitle">
            <span class="prelative before dinline-block">{{$params.newsType[typeId]['stitle']}}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        typeId: String,
        isBack: {
            type: Boolean,
            default: false
        },
        showTitle: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>
<style scope>
    .crumb {
        background: #f2f3f5;
    }

    .crumb .iconfont{
        top: 3px;
    }

    .stitle {

        border-bottom: 1px solid #f2f1f1;
        color: var(--mcolor);
    }

    .stitle>span {
        padding: 25px 20px 16px;
    }

    .stitle>span::before {
        left: 0;
        right: 0;
        bottom: -1px;
        height: 2px;
        background: var(--mcolor);
    }
</style>